/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2dnbC%7Bpadding-top%3A0%7D%0A._1ZnuxbdnbC%7Bpadding-right%3A0%7D%0A._1wydGWdnbC%7Bpadding-bottom%3A0%7D%0A._2Zuz6QdnbC%7Bpadding-left%3A0%7D%0A._30huDKdnbC%7Bborder%3A0%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._39xV02HZdu%7Bwidth%3A1px%7D%0A._0jFU0VHZdu%7Bheight%3A1px%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._1C7BHPdEFh%7Bclip%3Arect(1px%2C1px%2C1px%2C1px)%7D%0A._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");












import { type FC } from 'react';
import type { VisuallyHiddenProps } from './types';
const visuallyHiddenStyles = null;

/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */
const VisuallyHidden: FC<VisuallyHiddenProps> = ({
  children,
  testId,
  role,
  id
}) => {
  return <span id={id} data-testid={testId} role={role} className={ax(["_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7"])}>
			{children}
		</span>;
};
VisuallyHidden.displayName = 'VisuallyHidden';
export default VisuallyHidden;